import type { VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';
import { emptyMediaVariants } from '@/shared/ui/empty/empty-media-variants';

export function EmptyMedia({
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof emptyMediaVariants>) {
  return (
    <div
      data-slot="empty-icon"
      data-variant={variant}
      className={cn(emptyMediaVariants({ variant, className }))}
      {...props}
    />
  );
}
